<template>
  <div class="modal-content">
    <div class="modal-header">
      <h4 class="modal-title"><b>تأكيد إلغاء تقديم الطلب</b></h4>
      <a class="modal-close" @click="onClose"><i class="fa fa-times fa-lg" aria-hidden="true"></i></a>
    </div>
    <div class="modal-body">
      <h5 class="mb-2 text-success font-weight-bold"> هل أنت متأكد من إلغاء تقديم الطلب؟</h5>
      <p>علما بأن عند إلغاء تقديم الطلب سيتم حذف البيانات المدخلة في الطلب مسبقاً</p>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-link px-5 font-weight-bold" data-dismiss="modal" @click="onClose">عودة</button>
      <button type="button" class="btn btn-danger text-white px-5" @click="onCancel">الغاء الطلب</button>
    </div>
  </div>
</template>

<script lang="ts">
import { EventBus, Events } from '@/event-bus';
import { Component, Vue } from 'vue-property-decorator';

@Component
export default class CancelRequestComponent extends Vue {
  onCancel(): void {
    EventBus.$emit(Events.Request.ConfirmCancelRequestEvent);
    this.onClose();
  };

  onClose(): void {
    EventBus.$emit(Events.Dialog.CloseDialogEvent);
  }
}
</script>
<style scoped>
.modal-body {
  padding: 1em 2em !important;
}

.modal-body p {
  font-size: 1.1rem;
  margin-bottom: 0;
}
</style>
